import { expandGitRenameNumstatPath } from './expand-git-rename-numstat-path.js';
import { normalizeGitDiffPath } from './normalize-git-diff-path.js';
import type { ParsedNumstatEntry } from './types.js';

function parseNumstatCounts(parts: string[]): { additions: number; deletions: number } {
  const [a, d] = parts;
  return {
    additions: a === '-' ? 0 : parseInt(String(a), 10) || 0,
    deletions: d === '-' ? 0 : parseInt(String(d), 10) || 0,
  };
}

export function parseNumstatLine(line: string): ParsedNumstatEntry | null {
  const parts = line.split('\t');
  if (parts.length < 3) return null;
  const rawPath = parts[parts.length - 1]!;
  const { additions, deletions } = parseNumstatCounts(parts);
  const expanded = expandGitRenameNumstatPath(rawPath);
  const pathInRepo = normalizeGitDiffPath(expanded?.newPath ?? rawPath);
  return {
    pathInRepo,
    additions,
    deletions,
    ...(expanded ? { oldPathInRepo: expanded.oldPath } : {}),
  };
}

export function parseNumstatEntries(lines: string[]): Map<string, ParsedNumstatEntry> {
  const m = new Map<string, ParsedNumstatEntry>();
  for (const line of lines) {
    if (!line.trim()) continue;
    const parts = line.split('\t');
    if (parts.length < 3) continue;
    const rawPath = parts[parts.length - 1]!;
    const expanded = expandGitRenameNumstatPath(rawPath);
    const entry = parseNumstatLine(line);
    if (!entry) continue;
    const existing = m.get(entry.pathInRepo);
    if (!existing || expanded) {
      m.set(entry.pathInRepo, entry);
    }
  }
  return m;
}

export function parseNumstat(lines: string[]): Map<string, { additions: number; deletions: number }> {
  const m = new Map<string, { additions: number; deletions: number }>();
  for (const [path, entry] of parseNumstatEntries(lines)) {
    m.set(path, { additions: entry.additions, deletions: entry.deletions });
  }
  return m;
}
